import { Bell } from 'lucide-react';
import React from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import NotificationCenter from './NotificationCenter';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

const NotificationBell: React.FC = () => {
  const { unreadCount } = useNotifications();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="relative p-2 rounded-md hover:bg-gray-100 transition-colors" aria-label="Notifications">
          <Bell className="h-5 w-5 text-gray-600" />
          {unreadCount > 0 && (
            <span className="absolute -top-0.5 -right-0.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white">
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="p-0 w-auto" sideOffset={8}>
        <NotificationCenter />
      </PopoverContent>
    </Popover>
  );
};

export default NotificationBell;
